<template>
  <MainLayout />
</template>

<script>
import MainLayout from "@/layouts/MainLayout.vue";

export default {
  name: "App",
  components: { MainLayout },
};
</script>

<style>
/* Estilos globales, si los hay */
</style>
